export default __webpack_public_path__ + "static/media/pin.c928bf61.svg";